
/* Nav compare */
export const getNavCompareState = (state) => state.navCompareReducer;

/* Menu Panel*/
export const getSymbolsPanel = (state) => state.comparisonAndRotationMenuPanel.SymbolsPanelReducer
export const getGroupsPanel = (state) => state.comparisonAndRotationMenuPanel.GroupsPanelReducer
export const getMenuTab = (state) => state.comparisonAndRotationMenuPanel.MenuTabReducer
export const getLiquidityFilter = (state) =>state.comparisonAndRotationMenuPanel.LiqAndRatingFilterReducer
